import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { TabBar } from './TabBar';
import { useTabContext } from '@/contexts/TabContext';

interface MainContentAreaProps {
  isEditMode: boolean;
  setIsEditMode: (mode: boolean) => void;
}

/**
 * MainContentArea - Renders the left panel's TabBar and content.
 * The content is rendered via React Router's Outlet based on the current URL.
 * Split panel handling is done at the AppLayout level.
 */
export const MainContentArea: React.FC<MainContentAreaProps> = ({ 
  isEditMode, 
  setIsEditMode 
}) => {
  const { focusPanel, hasSplitPanel } = useTabContext();
  const location = useLocation();

  // When clicking anywhere in the left panel, focus it (only matters in split view)
  const handlePanelClick = () => {
    if (hasSplitPanel) {
      focusPanel('left');
    }
  };

  return (
    <div 
      className="flex flex-col min-h-0 h-full w-full max-w-full bg-surface overflow-x-hidden"
      onClick={handlePanelClick}
    >
      {/* Tab Bar for left panel */}
      <TabBar panel="left" />
      
      {/* Page Content */}
      <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
        <Outlet key={location.pathname} context={{ isEditMode, setIsEditMode }} />
      </div>
    </div>
  );
};